import React, { PureComponent, createContext } from "react"

export const defaultScrollerContext = {
  isActive: false,
  isScrolling: false,
  toggleScrolling: () => {},
}

export const ScrollerContext = createContext(defaultScrollerContext)

export class ScrollerProvider extends PureComponent<Props> {
  state = {
    ...defaultScrollerContext,
    toggleScrolling: () => {
      this.setState({ isScrolling: !this.state.isScrolling })
    },
    setActive: () => {
      this.setState({ isActive: true })
    },
  }

  render() {
    return (
      <ScrollerContext.Provider value={this.state}>
        {this.props.children}
      </ScrollerContext.Provider>
    )
  }
}
